import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { InfoBlock } from 'views/components/InfoBlock/InfoBlock';
import { SMART_PAYROLL_HOME_URL } from 'store/modules/app/constants';

export interface IStep {
  title: string;
  text: string;
  infoText?: string;
}

interface Props {
  intl: IntlShape;
  steps: IStep[];
  header: string;
}

export const NextStepsView = (props: Props) => {
  const {
    steps,
    header,
  } = props;

  return (
    <div className="NextSteps">
      <div className="NextSteps-title">
        <h1>{header}</h1>
      </div>

      <div className="Container">
        <div className="Grid-cell u-width1of1 u-lg-width3of4 Grid-cell--center">
          <div className="Tile">
            <FormattedMessage tagName="h2" id="NEXT_STEPS" />

            <ol className="NextSteps-list">
              {steps.map(({ title, text, infoText }, index) => (
                <li className="NextSteps-item" key={title}>
                  <div className="NextSteps-item-title">
                    <p className="NextSteps-item-index">{index + 1}</p>
                    <h3>{title}</h3>
                  </div>

                  <p>{text}</p>

                  {infoText && (
                    <div className="">
                      <InfoBlock
                        message={infoText}
                      />
                    </div>
                  )}
                </li>
              ))}
            </ol>

            <div className="NextSteps-button">
              <a
                href={SMART_PAYROLL_HOME_URL}
                className="Button Button--primary FlowButtonBar-primary"
              >
                <FormattedMessage id="BUTTON_BACK_TO_SMART_PAYROLL" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
